import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import connieFace from '../assets/connie-face-no-bckgn.png';
import { theme } from '../styles/theme';

interface ConnieAvatarProps {
  size?: number;
  style?: React.CSSProperties;
}

export function ConnieAvatar({ size = 64, style }: ConnieAvatarProps) {
  const [error, setError] = useState(false);

  return (
    <div style={{
      width: size, height: size, overflow: 'hidden',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      borderRadius: '50%', border: `2px solid ${theme.colors.tealBorder}`,
      padding: 4, background: 'white',
      ...style,
    }}>
      {error ? (
        <div style={{
          width: '100%', height: '100%',
          background: theme.colors.tealBg,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          borderRadius: 'inherit',
        }}>
          <Sparkles size={size * 0.5} color={theme.colors.teal} />
        </div>
      ) : (
        <img
          src={connieFace}
          alt="Connie"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          onError={() => setError(true)}
        />
      )}
    </div>
  );
}
